import { useRef } from "react";
import elevationMarkup from "./elevation.svg?raw";
import { useElevationInView } from "./useHeroIntro";

/**
 * The elevation study: a technical line drawing that draws itself, then
 * materialises into a finished, lit building.
 *
 * The SVG is injected as raw markup rather than converted to JSX. It is a
 * 42 KB build artifact generated by scripts/build-hero.sh, and every one of its
 * ~190 paths carries a `--t` timing offset in a `style` attribute plus `class`
 * hooks that the CSS animates. Hand-converting that to JSX would mean
 * maintaining a second copy that drifts from the drawing on the first edit.
 *
 * `dangerouslySetInnerHTML` is safe here in the way that matters: the content
 * is a checked-in asset from our own build, never anything a user supplies.
 */
export function Elevation() {
  const wrapper = useRef<HTMLDivElement>(null);
  const playing = useElevationInView(wrapper);

  return (
    <div
      ref={wrapper}
      className={`iea-hero__elev ${playing ? "elev-play" : "elev-wait"}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: elevationMarkup }}
    />
  );
}
